import { singleton } from 'tsyringe';

import type { EventTracker } from '@/application/interfaces/event-tracker.interface';
import { Event } from '@/application/interfaces/event-tracker.interface';
import { checkPocketLoaded, POCKET_SETTINGS } from '@/setupPocket';

import { PageViewEvent } from './pocket-events';

@singleton()
export class PocketEventTracker implements EventTracker {
  constructor() {
    if (window.POCKET && !window.POCKET_ENV) {
      window.POCKET.updateSettings(POCKET_SETTINGS);
    }
  }

  trackEvent(event: Event): void {
    checkPocketLoaded();
    window.POCKET.track(event.eventName, event.properties);
  }

  trackPageView(): void {
    if (!window.POCKET) {
      window.addEventListener('load', () => {
        this.trackEvent(new PageViewEvent());
      });
    } else {
      this.trackEvent(new PageViewEvent());
    }
  }
}
